export const getPropertyName = (shortName: string, name: string) => {
  if (shortName === "CCC" || shortName === "BMO") {
    if (name.includes(shortName)) {
      return name;
    }
  }
  return `${shortName} ${name}`;
};
